<!-- ALERT TOAST-->
<p-toast></p-toast>
<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<!-- OVERLAY SCREEN-->
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{translations.lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<div class="card" *ngIf="translations">

    <!-- GO BACK -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label=" {{ translations.lbl_go_Back }}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>

            <button pButton pRipple pTooltip="{{translations.lbl_new}}" icon="pi pi-plus" class="p-mr-4 z-5"
                (click)="openCreatePriceList(null)" [disabled]="isButtonDisabled"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12">
                    <!-- INFO -->
                    <div *ngIf="isButtonDisabled" class="warning-message">
                        {{monthsMessage}}
                    </div>
                    <!-- INPUT COUNTRY -->
                    <div *ngIf="security">
                        <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                            <span>{{translations.lbl_country}}</span>
                            <span class="p-text-bold">{{countrySelected.countryId}} {{countrySelected.descrip}}</span>
                        </div>
                    </div>

                    <!-- INPUT LENGUAJE -->
                    <div *ngIf="security" class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_language}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown [options]="listLanguage" [(ngModel)]="selectedLanguage" optionLabel="value"
                                [showClear]="true" placeholder="{{translations.lbl_language}}"
                                (onChange)="getData()"></p-dropdown>
                        </div>

                    </div>
                </div>
            </p-panel>
        </div>
    </div>

    <p-table #dt [value]="stores" responsive="true" [rows]="200" paginator="true"
        [globalFilterFields]="['listId','currDate','currCode','status','listScope','selected']" [columns]="[
                    { field: 'listId', header: '{{translations.lbl_id}} {{translations.lbl_list}}' },
                    { field: 'currDate', header: '{{translations.lbl_starting_date}}' },
                    { field: 'currCode', header: '{{translations.lbl_currency}}' },
                    { field: 'status', header: '{{translations.lbl_status}}' },
                    { field: 'listScope', header: '{{translations.lbl_scope}}' },
                    { field: 'selected', header: '{{translations.lbl_current_list}}' }]"
        currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_of}} {last} {{translations.lbl_records}}"
        [showCurrentPageReport]="true">
        <!-- CAPTION -->
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-left p-jc-between">
                <!-- OPTION BUTTON-->
                <span class="p-input-icon-left">

                </span>

                <!-- MAIN TITLE-->
                <h5 class="p-md-6">{{translations.lbl_zone_price_list}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{translations.lbl_search}}..." />
                </span>
            </div>
        </ng-template>



        <ng-template pTemplate="header">
            <!-- Order -->
            <tr>
                <th pSortableColumn="listId">{{translations.lbl_id}}<p-sortIcon field="listId"></p-sortIcon></th>
                <th pSortableColumn="currDate">{{translations.lbl_starting_date}}<p-sortIcon
                        field="currDate"></p-sortIcon></th>
                <th pSortableColumn="currCode">{{translations.lbl_currency}}<p-sortIcon field="currCode"></p-sortIcon>
                </th>
                <th pSortableColumn="status">{{translations.lbl_status}}<p-sortIcon field="status"></p-sortIcon></th>
                <th pSortableColumn="listScope">{{translations.lbl_scope}}<p-sortIcon field="listScope"></p-sortIcon>
                </th>
                <th pSortableColumn="selected">{{translations.lbl_current_list}} ({{translations.lbl_yes}} /
                    {{translations.lbl_no}})<p-sortIcon field="selected"></p-sortIcon></th>
                <th>{{translations.lbl_select}}</th>
            </tr>
            <!-- Filter -->
            <tr>
                <th>
                    <p-columnFilter type="text" field="listId"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="currDate"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="currCode"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="status"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="listScope"></p-columnFilter>
                </th>
                <th>
                    <p-columnFilter type="text" field="selected"></p-columnFilter>
                </th>
                <th></th>
            </tr>
        </ng-template>


        <ng-template pTemplate="body" let-item>
            <tr>
                <td>{{ item?.listId ?item.listId : 'S/N' }}</td>
                <td>{{ item?.currDate ?item.currDate : 'S/N'}}</td>
                <td>{{ item?.currCode ?item.currCode : 'S/N'}}</td>
                <td>{{ item?.status ?item.status : 'S/N'}}</td>
                <td>{{ item?.listScope ? item.listScopeDescrip : 'S/N' }}</td>
                <td>{{ item?.selected != null && item?.selected ? 'Sí' : 'No' }}</td>
                <td>
                    <button pButton pRipple icon="pi pi-search" class="p-button-rounded p-mr-2"
                        (click)="redirectToPriceListByList(item)"></button>
                    <button *ngIf="item?.status !== undefined && item?.status === constantsLocal.NEW_STATUS" pButton
                        pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2"
                        (click)="openCreatePriceList(item)">
                    </button>
                </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{translations.lbl_total}} {{stores ? stores.length : 0 }} {{translations.lbl_records}}.
            </div>
        </ng-template>
    </p-table>


</div>

<!-- TODO: FALTA ETIQUETA DE TITULO -->
<p-dialog
    header="{{ createUpdateDialog ? translations.lbl_new+ ' ' +translations.lbl_zone_price_list : translations.lbl_edit+ ' ' + translations.lbl_zone_price_list }}"
    [(visible)]="displayModalPriceList" styleClass="p-fluid" [modal]="true" [style]="{width: '50vw'}"
    [maximizable]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false">

    <div class="card">
        <!-- MAIN CONTENT -->
        <div class="p-grid">

            <!-- INFO -->
            <div class="p-col-12" [formGroup]="dataForm">

                <!-- INPUT LISTA VIGENTE -->
                <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                    <div class="subTitle p-col-12 p-md-4">
                        <span>{{translations.lbl_current_list}}:</span>
                    </div>
                    <div class="p-col-12 p-md-8">
                        <input *ngIf="storeSelected" type="text" pInputText
                            [value]="storeSelected.listId + ' '+ storeSelected.currDate" disabled="true">
                    </div>
                </div>

                <!-- INPUT PAÍS -->
                <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                    <div class="subTitle p-col-12 p-md-4">
                        <span>{{translations.lbl_country}}:</span>
                    </div>
                    <div class="p-col-12 p-md-8">
                        <input type="text" pInputText [value]="countrySelected.countryId + ' '+ countrySelected.descrip"
                            disabled="true">
                    </div>
                </div>

                <!-- INPUT FECHA DE INICIO -->
                <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                    <div class="subTitle p-col-12 p-md-4">
                        <span>{{translations.lbl_starting_date}}:</span>
                    </div>
                    <div class="p-col-12 p-md-8">
                        <p-inputMask id="dateSentSelectedModal" slotChar="DD/MM/YYYY"
                            pattern="^(0[1-9]|1[0-9]|2[0-9]|3[0-1])/(0[1-9]|1[0-2])/(\d{4})$" mask="99/99/9999"
                            value="2023-01-01" placeholder="DD/MM/YYYY" formControlName="startDate"></p-inputMask>
                    </div>
                </div>

                <!-- INPUT ALCANCE -->
                <!-- <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                    <div class="subTitle p-col-12 p-md-4">
                        <span>{{translations.scope}}:</span>
                    </div>
                    <div class="p-col-12 p-md-8">
                        <div class="p-d-flex p-jc-around responsiveInput" style="margin-top: 1rem;">
                            <div class="p-field-radiobutton">
                                <p-radioButton name="scope" [value]="true" inputId="city1"
                                    formControlName="scope"></p-radioButton>
                                <label for="city1">Aplicar a nacionales de toda Zona</label>
                            </div>
                            <div class="p-field-radiobutton">
                                <p-radioButton name="scope" [value]="false" inputId="city2"
                                    formControlName="scope"></p-radioButton>
                                <label for="city2">Aplicar a locales en un solo país</label>
                            </div>
                        </div>
                    </div>
                </div> -->

            </div>

        </div>
    </div>

    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
            class="p-button-warning p-mr-2" (click)="displayModalPriceList=false"></button>

        <button pButton pRipple type="button" icon="pi pi-check" label="{{translations.lbl_save}}"
            class="p-button-raised p-button-success" (click)="createUpdatePriceList()"></button>
    </ng-template>
</p-dialog>